







import Vue from 'vue'
export default Vue.extend({
  props: {
    pending: {
      type: Boolean
    },
    text: {
      type: String
    }
  }
})
